import '../App.css';
import './NewScreen.css';
import React from 'react';
import { Page, Msg, Footer, FooterLinks, FooterLink, FooterText, Panel, PanelBody, PanelHeader} from 'react-weui';
import 'weui';
import 'react-weui/build/packages/react-weui.css';
import GlobalTools from "../utils/GlobalTools";
import withRouter from "../withRouter"

class MyScreen extends React.Component {

    constructor(props) {
        super(props);
        console.log("构造器初始化");

        this.state = {
            qrcode:"https://cdn.zuime.com/hmb/hmbqr.jpg",
            u: props.router.params.u
        };

        //持久化U
        GlobalTools.writeU( props.router.params.u);
        //确保使用https
        GlobalTools.fixHttps(); 
    };

    
    componentWillMount(){

     }

    componentDidMount(){
      
    }
    
    render() {
        let {u} = this.state;
        return (
         <Page title="个人中心" subTitle="号码宝转让平台个人中心" infiniteLoader={false}
         ptr={false} >
    
            <Msg
                type="info"
                title="个人中心"
                description="用微信关注【号码宝】公众号，进入【转让求购】"
                buttons={[  {
                    type: 'default',
                    label: '返回',
                    onClick: () => this.props.router.navigate(`/trade/index/${u}`)
                }]}
    
            />

            <Panel>
                <PanelHeader className='hmb-new-trade-qrtxt'>号码宝公众号二维码</PanelHeader>
                <PanelBody>  <img className='hmb-new-trade-qr' src={this.state.qrcode}/></PanelBody>
            
            </Panel>

         </Page>
       );
    }

}


export default withRouter(MyScreen);